/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      // El SW nuevo ya esta activo (skipWaiting en vue.config.js); solo falta
      // recargar para que la pagina tome el bundle nuevo. App.vue escucha este
      // evento y decide el momento: inmediato en login, diferido en sesion.
      console.log('New content is available; notifying app.')
      document.dispatchEvent(new CustomEvent('swUpdated'))
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
